import { IReducedAnswerState } from '@/modules/SurveyForm';
import { DeleteIcon } from '@chakra-ui/icons';
import {
  Box,
  IconButton,
  Tag,
  TagLabel,
  Text,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ExporterFavorite } from '../hooks/useExporterFavorites';

interface FavoritesListProps {
  favorites: ExporterFavorite[];
  activeFavoriteId: string | null;
  onApplyFavorite: (values: IReducedAnswerState) => void;
  onDeleteFavorite: (id: string) => void;
}

export const FavoritesList: React.FC<FavoritesListProps> = ({
  favorites,
  activeFavoriteId,
  onApplyFavorite,
  onDeleteFavorite,
}) => {
  const { t } = useTranslation();

  const handleApplyFavorite = useCallback(
    (favorite: ExporterFavorite) => {
      onApplyFavorite(favorite.values);
    },
    [onApplyFavorite],
  );

  const handleDeleteFavorite = useCallback(
    (e: React.MouseEvent, favoriteId: string) => {
      e.stopPropagation();
      onDeleteFavorite(favoriteId);
    },
    [onDeleteFavorite],
  );

  if (favorites.length === 0) {
    return null;
  }

  return (
    <Box mb={3}>
      <Text fontSize="xs" color="gray.500" mb={2}>
        {t('common.favorites', 'Favoritos')}
      </Text>
      <Wrap spacing={2}>
        {favorites.map((favorite) => (
          <WrapItem key={favorite.id}>
            <Tag
              size="md"
              variant={activeFavoriteId === favorite.id ? 'solid' : 'subtle'}
              colorScheme="primary"
              cursor="pointer"
              onClick={() => handleApplyFavorite(favorite)}
              _hover={{ opacity: 0.8 }}
            >
              <TagLabel>{favorite.name}</TagLabel>
              <IconButton
                aria-label="Remover favorito"
                icon={<DeleteIcon />}
                size="xs"
                variant="ghost"
                colorScheme="red"
                ml={1}
                minW="auto"
                h="auto"
                p={0.5}
                onClick={(e) => handleDeleteFavorite(e, favorite.id)}
              />
            </Tag>
          </WrapItem>
        ))}
      </Wrap>
    </Box>
  );
};

export default FavoritesList;
